const action = {
    general: '執行流程擴充時發生錯誤，請稍後重試。',
    sign_in_identifier_changed: '流程擴充無法變更本次驗證使用的登入識別碼。',
};
export default Object.freeze(action);
